import { DEFAULT_GAME_TZ, isValidTimeZone } from '@shared/time.js';

/**
 * אזור הזמן של המבצע כפי שהמנהל הגדיר בהגדרות (למשל Europe/Paris כשהמבצע בחו"ל). כל התאריכים והשעות באפליקציה
 * מוצגים בו, ושעות "אפשור זמן" מתפרשות לפיו. מתעדכן מהשרת בכל טעינת מצב.
 */
let zone = DEFAULT_GAME_TZ;

export function setGameTimeZone(next: string | null | undefined): void {
  if (next && next !== zone && isValidTimeZone(next)) zone = next;
}

export function gameTimeZone(): string {
  return zone;
}

/** אזור הזמן של המכשיר הזה (אצל שחקן בחו"ל הטלפון מתחלף לשעון המקום אוטומטית) */
export function deviceTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}

/** תצוגת תאריך/שעה בעברית באזור הזמן של המבצע */
export function formatInGameZone(iso: string, options: Intl.DateTimeFormatOptions): string {
  try {
    return new Intl.DateTimeFormat('he-IL', { timeZone: zone, ...options }).format(new Date(iso));
  } catch {
    return iso;
  }
}
